export default __webpack_public_path__ + "static/media/summary_banner2.d1c78ac1.png";